import Heading from '../../components/Heading/Heading';
import NavBar from '../../components/NavBar/NavBar';

const Reports = () => {
     return (
            <>
                <NavBar />
                <section className="content home">
                    <Heading title="Dashboard" />
                    <div className="container-fluid">
                        <div className="row clearfix">
                            <div className="col-lg-12">
                                <div className="card">
                                    <div className="body">
                                        <h1 className="text-center">Working Progress</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
}

export default Reports;